import { MessageService, Message } from 'primeng/api';
import { Component, OnInit } from '@angular/core';
import { MsgService } from 'src/app/services/message.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent implements OnInit {

  position: string = 'top-right';
  showMessage: Subject<{message: Message, position: string}> = this.msgService.show;

  constructor(
    private msgService: MsgService,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.showMessage.subscribe((val: {message: Message, position: string}) => {
      if (val && val.message) {
        this.messageService.add(val.message);
        if (val.position) {
          this.position = val.position;
        }
      }
    });
  }

}
